import React from 'react';

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';

export const rightTabs = [
  {
    icon: <InsertDriveFileIcon data-testid="InsertDriveFileIcon" />,
    id: 'documents',
  },
  { icon: <InsertPhotoIcon data-testid="InsertPhotoIcon" />, id: 'images' },
];
